<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <!-- <el-select class="search_select search_inputBox"  v-model="params.status" placeholder="订单状态">
                <el-option :value="0" :label="'未完成'"></el-option>
                <el-option :value="1" :label="'已完成'"></el-option>
                <el-option :value="999" :label="'全部状态'"></el-option>
            </el-select> -->
            <el-select class="search_select search_inputBox" v-model="params.purchase_type" multiple collapse-tags placeholder="数据来源" filterable @visible-change="getSelectList('purchaseType')">
                <el-option v-for="list in selectMap.purchaseType" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.cargo_status" placeholder="资源状态" clearable filterable @visible-change="getSelectList('cargoStatus')">
                <el-option v-for="list in selectMap.cargoStatus" :key="list.id" :value="list.id" :label="list.name"></el-option>
                <!-- <el-option v-for="list in selectMap.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option> -->
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.fee_status" collapse-tags placeholder="添加费用" clearable filterable>
                <el-option :value="1" label="已添加费用"></el-option>
                <el-option :value="0" label="未添加费用"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox" v-model="params.pay_status" multiple collapse-tags placeholder="付款状态" clearable filterable>
                <el-option :value="2" label="已付"></el-option>
                <el-option :value="0" label="未付"></el-option>
                <el-option :value="1" label="部分付款"></el-option>
            </el-select> -->
            <el-select class="search_select search_inputBox" v-model="params.settlement_status" placeholder="结算状态" @visible-change="getSelectList('purchaseSettlementStatus')">
                <el-option v-for="list in  selectMap.purchaseSettlementStatus" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" placeholder="供应商" clearable filterable @visible-change="getSelectList('supplier')">
                <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                <!-- <el-option v-for="list in selectMap.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option> -->
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" clearable filterable @visible-change="getSelectList('breed')">
                <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" clearable filterable @visible-change="getSelectList('brand')">
                <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.grade_id" multiple collapse-tags placeholder="等级" clearable filterable @visible-change="getSelectList('grade')">
                <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore"  v-model="params.bill_lading_no" placeholder="提单号"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore"  v-model="params.container_no" placeholder="货柜号"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore"  v-model="params.creator_id" multiple collapse-tags placeholder="制单人" clearable filterable @visible-change="getSelectList('creater')">
                <el-option v-for="list in selectMap.creater" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore"  v-model="params.remark" placeholder="备注"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-order-add-fee,')!=-1" @click="addFee">添加费用</el-button> 
            <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-order-add-fee,')!=-1" @click="addReturnOrder">新建退货单</el-button>
            <div class="upimgBtnBox" v-if="module.indexOf(',purchase-upload-files,')!=-1" @click="bacthUpFile">
                <div class="upFileBtnImg"></div>
                <div class="upimgBtnTitle">上传文件</div>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="purchase.sales.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @relativefile="relativeFile" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">调货数量:{{totalObj.total_sum}}</div>
            <div class="totalNumber">采购金额:{{totalObj.rmb_cost_amount}}</div>
            <div class="totalNumber">费用金额:{{totalObj.fee_amount}}</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogReturnVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="purchaseTypeText" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <!-- <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA"> -->
                        <div class="elFormBox">
                            <el-form-item  label="供应商名称：">
                                <el-select  v-model="form_params.supplier_id" :disabled="!purchaseTypeEdit"  @visible-change="getSelectList('supplier',$event)">
                                    <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <!-- <el-form-item  label="退货人：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.supplier" :disabled="true"></el-input>
                            </el-form-item> -->
                            <el-form-item  label="退货人：" prop="salesman_id">
                                <!-- :disabled="!saleOrderIsEdit" -->
                                <el-select  v-model="form_params.returner_id" :disabled="!purchaseTypeEdit"  @visible-change="getSelectList('user',$event)">
                                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="退货日期：">
                                <el-date-picker v-model="form_params.date" :disabled="!purchaseTypeEdit" type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elDialogElFormBoxCheckbox">
                            <img  src="/icon/operation_edits.png" v-if="purchaseTypeEdit" @click="amend" class="form_edits">
                            <el-form-item  label="REC：">
                                <el-checkbox :disabled="true" v-model="form_params.rec"></el-checkbox>
                                <el-input v-model="form_params.tax_rate" :disabled="true" v-if="form_params.rec&&rec_params.with_ticket==0" @input="calculationTableTotal(),recDigit($event)" placeholder="税率%：" class="checkbox elDialogElFormBoxCheckboxREC"></el-input>
                                <el-input v-model="form_params.amount" :disabled="true" v-if="rec_params.with_ticket==1" @input="calculationTableTotal(),recDigit($event)" class="checkbox"></el-input>
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn" @click="filterDialogVisibleA=!filterDialogVisibleA"></div>
                    <!-- </el-form> -->
                </el-form>
                <div class="">
                    <div class="editBox">
                        <div class="inwardRoll">
                            <!-- <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column type="selection" v-if="purchaseTypeEdit" :selectable="checkSelectable" width="50"></el-table-column>
                                <el-table-column key="2" label="操作" width="75" v-if="purchaseTypeEdit">
                                        <template slot-scope="scope">
                                            <div class="icon_wrap">
                                                <i class="operation_add" @click="addTo()" title="添加"></i>
                                                <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                            </div>
                                        </template>
                                 </el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <span >
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table> -->
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column type="selection" v-if="purchaseTypeEdit" :selectable="checkSelectable" width="50"></el-table-column>
                                <el-table-column key="2" label="操作" width="75" v-if="purchaseTypeEdit">
                                        <template slot-scope="scope">
                                            <div class="icon_wrap">
                                                <i class="operation_add" @click="addTo()" title="添加"></i>
                                                <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                            </div>
                                        </template>
                                 </el-table-column>
                                 <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <span >
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                        <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应退</div>
                            <div class="dialogTotalC" v-if="tableTotal.return_amount">退款金额:-{{tableTotal.return_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.tax_amount">税金:-{{tableTotal.tax_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.refund_amount">应退金额:-{{tableTotal.refund_amount}}</div>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <span class="redColor" style="padding-top: 7px;">*</span>
                    <div class="returnReason">
                        <textarea class="remarkTextarea" :disabled="!purchaseTypeEdit" :readonly="false" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                    </div>
                    <div class="editLeft">
                        <textarea class="remarkTextarea" :disabled="!purchaseTypeEdit" :readonly="false" v-model="form_params.ship_no" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson" v-if="form_params.creator_name">制单人：{{form_params.creator_name}}</div>
                    <!-- <div class="editPerson">审核人：{{form_params.auditor_name}}</div> -->
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;margin-bottom: 10px;">
                        <!-- v-if="orderType===1||detailInfo.saleOrderIsEdit&&module.includes('order-fee-add')&&!(detailInfo.status==5||detailInfo.status==6||detailInfo.status==7)" -->
                        <el-button class="funcPublicBtnEdit" v-if="purchaseTypeEdit" style="line-height: 25px;"  @click="openbusinessRelation">关联退货费用</el-button>
                        <!-- <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <img src="../../assets/top-delete-suspension.png" v-if="!detailInfo.id" class="newFeeImg" @click="delOutFee(index)"/>
                                <img src="../../assets/top-delete-suspension.png" v-else-if="detailInfo.isDeleteFee==1" class="newFeeImg" @click="isDeleteFee(list.id)"/>
                            </div>
                        </div> -->
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div>
                    </div>
                    <!-- <div style="float:left;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div>
                    </div> -->
                    <div class="editBtn">
                        <el-button class="funcPublicBtn " @click="dialogReturnVisible=false">关闭</el-button>  
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="purchaseTypeEdit" @click="confirmReturn">确认退货</el-button>  
                        <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addDialogVisibleBack = true;add_params.supplier_id = form_params.supplier_id;add_params.ids = [form_params.id];add_params.contract_no = form_params.contract_no;purchaseShow =true">付款</el-button>
                        <el-button class="funcPublicBtn" @click="openBill">收发票</el-button>
                        <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                        <el-button class="funcPublicBtn" @click="exportExcelBill">导出</el-button> -->
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <el-dialog v-dialog-drag :visible.sync="isEditPurchase" class="eldialog eldialogLine" :modal="false" :title="purchaseType==1?'修改退货单':'修改调货单'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :model="purchaseForm" class="clearfix dialogFormB">
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="purchaseForm.contract_no" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id">
                        <el-select v-model="purchaseForm.supplier_id" filterable clearable @visible-change="getSelectList('supplier')">
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="调货人：" prop="clerk_id">
                         <el-select v-model="purchaseForm.clerk_id" filterable clearable @visible-change="getSelectList('creater')">
                            <el-option v-for="list in selectMap.creater" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-input v-model="purchaseForm.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no">
                        <el-input v-model="purchaseForm.container_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="purchaseForm.remark"></el-input>
                    </el-form-item>
                    <!-- <div class="elFormBox">
                    </div>
                    <div class="elFormBox">
                    </div>
                    <div class="elFormBox">
                    </div> -->
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="purchaseUpdate">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="isShowCost" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :model="feeForm" :rules="feeFormRules" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="feeForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no_copy">
                        <el-input v-model="feeForm.contract_no_copy" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-select v-model="feeForm.bill_lading_no" multiple collapse-tags filterable clearable  @visible-change="feeChange('bill_lading_no')">
                            <el-option v-for="(list,index) in bill_lading_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no">
                        <el-select v-model="feeForm.container_no"  multiple collapse-tags filterable clearable  @visible-change="feeChange('container_no')">
                            <el-option v-for="(list,index) in container_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="feeForm.fee_id"  @visible-change="getSelectList('purchaseCost')" filterable clearable>
                            <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="feeForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="feeForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="feeForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="feeForm.remark"></el-input>
                    </el-form-item>
                    <!-- <div class="elFormBox">
                    </div>
                    <div class="elFormBox">
                    </div>
                    <div class="elFormBox">
                    </div> -->
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveFee">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="seeRemarksFlag" class="eldialog eldialogA" width="500px" :modal="false" title="其它备注" custom-class="full_dialog">
            <div class="remarksBox">
                <div class="remarksText" v-show="seeRemarks.length>0" v-for="(item,index) in seeRemarks" :key="index">{{(index+1)+'、'+item.remark}}</div>
                <div class="remarksText" v-show="seeRemarks.length<=0" style="text-align:center">无</div>
            </div>
        </el-dialog>
        <!-- 规格详情 START -->
        <el-dialog v-dialog-drag :visible.sync="specDetailFlag" class="eldialog specTable" width="750px" :modal="false" title="详细规格及采购单价" custom-class="full_dialog">
            <el-table :data="specDetail" border stripe highlight-current-row size="mini" height="100%" style="max-height:400px">
                <el-table-column label="品名" prop="breed" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" prop="spec_text" show-overflow-tooltip></el-table-column>
                <el-table-column label="等级" prop="grade" show-overflow-tooltip></el-table-column>
                <el-table-column label="属性" prop="attribute" show-overflow-tooltip></el-table-column>
                <el-table-column label="单价" prop="cube_price" show-overflow-tooltip></el-table-column>
                <el-table-column label="立方" prop="cube" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;">
                    <span>合计：码单方数：{{cubeTotal.cube}}</span>
                    <span style="padding-left: 25px;">采购金额：{{cubeTotal.amount}}</span>  
                </div>
            </div>
        </el-dialog>
        <!-- 规格详情 END -->
        <!-- 规格详情 START -->
        <el-dialog v-dialog-drag :visible.sync="costDetailFlag" class="eldialog specTable" width="750px" :modal="false" title="成本费用明细" custom-class="full_dialog">
            <el-table :data="costDetail" border stripe highlight-current-row size="mini" height="100%" style="max-height:400px">
                <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="平摊日期" prop="fee_date" show-overflow-tooltip></el-table-column>
                <el-table-column label="费用名称" prop="fee_name" show-overflow-tooltip></el-table-column>
                <el-table-column label="平摊单价" prop="cost_price" show-overflow-tooltip></el-table-column>
                <el-table-column label="费用金额" prop="amount" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作人" prop="creator_name" show-overflow-tooltip></el-table-column>
            </el-table>
            <div class="readBtnDiv" style="padding: 10px 0 0;">
				<el-button size="small" class="readBtn funcPublicBtnChecked" @click="costDetailFlag = false">我知道了</el-button>
			</div>
        </el-dialog>
        <!-- 规格详情 END -->
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveFile">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFile = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <!--关联退货费用 START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加关联退货费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--关联退货费用END-->
        <!--REC START -->
        <el-dialog  v-dialog-drag title="税金修改" :visible.sync="recChanges"
                width="350px" class="eldialog no_print eldialogLine" :model="false" custom-class="full_dialog">
            <el-form :model="rec_params" :rules="recRules"  :inline="true" class="dialogFormB clearfixe"
                size="mini">
                <div class="eldialogFormBox">
                    <el-form-item label="REC：" >
                        <el-checkbox class="taxCheck" v-model="rec_params.rec" style="margin-right: 10px;"></el-checkbox>
                        <!-- <el-input  v-model="rec_params.tax_rate"  style="width:145px;" v-digits:4="rec_params.tax_rate" @input="change($event)" class="formInput tax_rate">
                        </el-input>
                        <span style="position: absolute;right: 5px;">%</span> -->
                    </el-form-item>
                    <el-form-item label="是否含票价：" v-if="rec_params.rec">
                        <el-select v-model="rec_params.with_ticket" placeholder="" >
                            <el-option :value="0"  label="否"></el-option>
                            <el-option :value="1"  label="是"></el-option>
                        </el-select>
                    </el-form-item> 
                    <el-form-item  label="税率："  v-if="rec_params.with_ticket==0&&rec_params.rec" class="dialogTwo clearfix" prop="tax_rate" >
                        <el-select class="twoSelect" v-model="rec_params.rec_type" placeholder="" >
                            <!-- @change="TaxesTableTotal()"  -->
                            <el-option :value="'MUL'"  label="×"></el-option>
                            <el-option :value="'DIV'"  label="÷"></el-option>
                        </el-select>
                        <!-- @input="exchangeRate" -->
                        <el-input class="twoInput"  v-model="rec_params.tax_rate"></el-input>
                        <!-- @input="TaxesTableTotal()" -->
                    </el-form-item>
                    <el-form-item label="税金：" v-if="rec_params.with_ticket==0&&rec_params.rec">
                        <el-input class="formInput" v-model="rec_params.amount" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="税金：" v-if="rec_params.with_ticket==1&&rec_params.rec">
                        <el-input class="formInput" v-model="rec_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <textarea style="min-height: 60px;" class="edit_input edit_textarea formInput" v-model="rec_params.remark">
                        </textarea>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="outRecChanges()">取消</el-button>
                <el-button  class="publicBtn dialogBtn"  @click="settlementConfirm">确定</el-button>
            </div>
        </el-dialog>
        <!--REC END -->
        <!--选择库存START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1160px" :modal="false" title="选择货物" custom-class="full_dialog">
            <return-stock ref="selectStock" :supplier_id="form_params.supplier_id" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></return-stock>
        </el-dialog>
        <!--选择库存END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="purchase.sales.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="purchase.return.create" :filterDialogVisible="filterDialogVisibleA" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleA = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
    </div>
</template>
<style scoped>
.elFormBoxBtnList .funcPublicBtnChecked{margin-left:50px;}
.labelTip{display: none;position: absolute;bottom:20px;left:-150px;z-index:1;width:400px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
.laCbelTipC{color:#606266;font-size: 12px;}
.labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
.contractLabel:hover{cursor: pointer;}
.contractLabel:hover .labelTip{display: block;}
.remarksText{text-align: left;padding:5px 10px;}
.form_edits{width:20px;position: absolute;left: 20px;}
.editBtnList{padding-top: 10px;}
.editBtn{float: right;}
.upFileOutBox .upFileBox{width:100%;margin-bottom:10px;border-radius: 5px;box-shadow: 0 0 5px #ccc;padding:2px 10px;margin-top:10px;}
.upFileOutBox .upFile{display: block;float: left;font-size: 14px;}
.upFileOutBox .upFileRemove{width:15px;height:15px;float:right;cursor:pointer;margin-top:2px;}
.upFileOutBox .uploadFileAdd{width:60px;height:50px;display: block;margin:auto;margin-top:10px;}
.upFileOutBox .upload-demo{width:100%;height:100px;overflow: hidden;}
.upFileOutBox .uploadTitle{width:100%;text-align: center;font-size: 14px;margin-top:5px;}
</style>
<script>
import tabletem from '../../components/table.vue'
import pagination from '../../components/pagination.vue'
import relativeFile from '../../components/downloadRelativeFile.vue';
const initDetailItem = {
    isSelect:1,
    original_bale: "",
    contract_no: "",
    opening_company: "",
    contract_no: "",
    warehouse: "",
    storage_location: "",
    bale_no: "",
    status_text: "",
    supplier: "",
    place_origin:"",
    brand: "",
    breed: "",
    sales_breed: "",
    attribute: "",
    thumbnail: "",
    grade: "",
    sales_thickness: "",
    files: [],
    color: "",
    sales_length: "",
    pieces:"",
    layer_number:"",
    sales_width_total:"",
    sales_cube:"",
    out_cube:"",    
};
const initDetailList = [initDetailItem];
const initBusinessRelationForm = {
    fee_date:new Date(),
    fee_id: "",
    fee_name: "",
    payee: "",
    amount: "",
    is_invoice: "",
    remark: ""
};
export default {
    data(){
        return{
            tableLoading:false,
            module:localStorage.dw_erp_power_code,
            isEditPurchase:false,//修改调货单弹框
            // actual_arrival_time:"",
            // payment_time:"",
            // receipt_invoice:"",
            // contract_time:"",
            // expected_arrival_time:"",
            // expected_shipping_time:"",
            categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
            categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
            isShowMore:false,
            start_time:"",
            end_time:new Date(),
            payment_time:"",
            costTable:[
                {date:""}
            ],
            contractType:2,//2新增 3修改
            isShowCost:false,
            feeList:[],
            feeForm:{
                fee_date:"",
                purchase_id:"",
                contract_no:"",
                container_no :"",
                bill_lading_no:"",
                fee_id:"",
                payee:"",
                amount:"",
                is_invoice:"",
                remark:""
            },
            feeFormRules:{
                fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                purchase_id:[ { required: true, message: '请填写采购合同', trigger: 'blur' }],
                contract_no_copy:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                // bill_lading_no:[ { required: true, message: '请填写提单号', trigger: 'blur' }],
                fee_id:[ { required: true, message: '请填写费用名称', trigger: 'blur' }],
                payee:[ { required: true, message: '请填写收款单位(人)', trigger: 'blur' }],
                amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                is_invoice:[ { required: true, message: '是否提供发票', trigger: 'blur' }]
            },
            contractForm:{
                id:"",
                contract_no:"",
                contract_time:"",
                supplier_id:"",
                ship_no:"",
                breed_id:"",
                batch_no:"",
                pieces:"",
                heap_no:"",
                cube:"",
                cube_price:"",
                foreign_currency_id:"",
                foreign_currency_amount:"",
                rmb_amount:"",
                expected_pay_time:"",
                payment_time:"",
                expected_arrival_time:"",
                payer:"",
                remark:"",
                remarks:[]
            },
            contractRules: {
                contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                contract_time:[ { required: true, message: '请填写合同日期', trigger: 'blur' }],
                ship_no:[ { required: true, message: '请填写船名', trigger: 'blur' }],
                pieces:[ { required: true, message: '请填写根数', trigger: 'blur' }],
                breed_id:[ { required: true, message: '请填写树种', trigger: 'blur' }],
                batch_no:[ { required: true, message: '请填写批次号', trigger: 'blur' }],
                length:[ { required: true, message: '请填写长度', trigger: 'blur' }],
                foreign_currency_id:[ { required: true, message: '请填写外币类型', trigger: 'blur' }],
            },
            params:{
                start_time:"",
                end_time:"",
                // status:'',
                purchase_type:[],
                contract_no:"",
                fee_status:"",
                pay_status:[],
                supplier_id:[],
                breed_id:[],
                brand_id:[],
                grade_id:[],
                creator_id:[],
                bill_lading_no:'',
                container_no:'',
                remark:'',
                page:1,
                per_page:50
            },
            last_page:1,
            total:0,
            selectRow:[],
            categoryList:[],
            selectMap:{
                supplier:[],
                breed:[],
                brand:[],
                creater:[],
                grade:[],
                port:[],
                purchaseCost:[],
                currency:[],
                payerList:[],
                purchaseType:[],
                user:[],
                cargoStatus:[],
                purchaseSettlementStatus:[],
            },
            list:[],
            tableCol:[
                {colName:"数据来源",colKey:"purchase_type_text",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"调货日期",colKey:"contract_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                {colName:"结算状态",colKey:"settlement_status_text",colWidth:80,isSetWidth:true,htmlNodeFunc(row) {
                    let color = row['settlement_status'] ==0 ? 'red' : '';
                    return `<span style="color:${color}">${row[this.colKey]}</span>`;
                },isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isRong:true,isShow:true,},
                {colName:"供应商",colKey:"supplier",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"品名",colKey:"breed",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"品牌",colKey:"brand",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"规格详情",colKey:"info_summary",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true},
                {colName:"调货数量",colKey:"order_number",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"采购金额",colKey:"purchase_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"费用金额",colKey:"purchase_cost",colWidth:100,isSetWidth:true,isCanClick:true,isShow:true},
                {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                {colName:"关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true},
                {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true}
            ],
            totalObj:{},
            bill_lading_no_list:[],
            container_no_list:[],
            filterDialogVisible:false,
            filterDialogVisibleA:false,//新建弹框列设置
            isGlobal:false,
            filter:"",
            fields:"",
            breedList:[],
            seeRemarks:[],
            seeRemarksFlag:false,
            selectMapS:{
                supplier_id:[],
            },
            purchaseForm:{
                contract_no:'',
                supplier_id:[],
                bill_lading_no:'',
                clerk_id:'',
                container_no:'',
                remark:'',
            },
            specDetailFlag:false,
            specDetail:[],
            cubeTotal:{},
            costDetailFlag:false,//成本费用框
            costDetail:[],
            category:'',
            dialogVisibleFile:false,
            importDialogVisible:false,
            upFileObj:{
                ids:[],
                files:[]
            },
            upFileList:[],
            upload_data : {},
            oss : {
                host : "",
            },
            ownLoadFileDialog:false,
            downFilesList:[],
            downLoadFileDialog:false,
            dialogReturnVisible:false,//采购退货单
            form_params:{
                supplier_id:"",
                returner_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                date:new Date(),
                rec:0,
                details:[],
                fees:[],
                ship_no:"",
                remark:"",
                // inventory_id:"",
            },
            filterDialogVisible:false,
            filterDialogVisibleB:false,
            filter:"",
            filters: [],
            listDetail:this.$cloneJson(initDetailList),
            businessRelation: false,
            outFeeSelect: [],
            businessRelationForm: this.$cloneJson(initBusinessRelationForm),
            feeOutFormRlues: {
                fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
            },
            newFee: [],
            rec_params:{
                rec:'',
                rec_type:'MUL',
                with_ticket:'',
                tax_rate:'',
                amount:'',
                remark:'',
            },
            recChanges:false,
            f_rec:'',
            recRules:{
                tax_rate: [{ required: true, message: '不能为空', trigger: 'change' }],
            },
            dialogVisibleStock:false,
            orderIsEdit:true,
            tableTotal:{
                return_amount:0.00,
                tax_amount:0.00,
                refund_amount:0.00,
            },
            purchaseType:0,
            order_id:'',
            purchaseTypeEdit:true,
            purchaseTypeText:'',
            ispurchaseUpdate:false,
        }
    },
    created(){
        this.order_id=sessionStorage.FINISHED_PRODUCT_ORDER_ID;
        sessionStorage.removeItem("FINISHED_PRODUCT_ORDER_ID")
        this.getSelectList("user")
        this.getSelectList("supplier")
        this.getSelectList("cargoStatus")
        this.getSelectList("breed")
        this.getSelectList("payerList")
        // this.getSelectList("creater")
        // this.getSelectList("grade")
        // this.getSelectList("port")
        // this.getSelectList("purchaseCost")
        this.getSelectList("currency")
        this.getSelectList("purchaseType")
        this.getSelectList("purchaseSettlementStatus")
        this.postFunc("/erp/purchase.category",{},res=>{
            this.categoryList=res.data.data;
            if(res.data.data.length==1){
                this.contractForm.category=res.data.data[0].id
            }
        },error=>{
            this.tip(error.data.message,"warning")
        })
        this.tableColCopy = this.$deepClone(this.tableCol);
        this.getList()
        // this.getBreed()
    },
    methods:{
        headDrog(newWidth, oldWidth, column) {
            this.filters.forEach((item) => {
                if (column.property == item.colKey) {
                    item.colWidth = newWidth;
                }
            });
            let obj = {};
            obj.width = parseInt(newWidth);
            obj.name = column.property;
            let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
            bus.$emit(emit, obj);
        },
        checkSelectable(row){
            return true;
            // if(row.isSelect==1){
            // }else{
            //     return false;
            // }
        },
        getSelectsalePurchase(target){
            this.$getSelectsalePurchase(target,{supplier_id:this.params.supplier_id}).then(res=>{
                this.selectMapS[res.data.data.target]=res.data.data.result;
            })
        },
        remarksAdd(){
            this.contractForm.remarks.push({remark:""})
        },
        remarksRemove(index){
            this.contractForm.remarks.forEach((item,ind)=>{
                if(index==ind){
                    this.contractForm.remarks.splice(ind,1)
                }
            })
        },
        getBreed(){
            this.postFunc("/erp/processing.wood.breed",{processing_id:this.processing_id},res=>{
                this.breedList = res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        filterConfirm(){
            if(this.isGlobal){
                this.getBillColumn()
            }else{
                this.getList()
            }
        },
        getBillColumn(){
            this.filters = [];
            this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                this.filter = response.data.data.columns;
                this.filters = response.data.data.columns;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getTableSummaries(params) {
            return this.$setSummaryFields(params, {
                total_amount: 2,//金额
                cube: 4,//码单立方
            },total=>{
            });
        },
        //选择库存信息
        selectData(row){
            this.listDetailSet(row)
        },
        selectAndOut(row){
                this.listDetailSet(row)
                this.dialogVisibleStock = !this.dialogVisibleStock;
            },
        listDetailSet(row){
            if(row.length<1){
                    return;
                }
                let rows = this.$cloneJson(row);
                rows.forEach(item=>{
                    item.inventory_id=item.id;
                    item.id="";
                    if(item.inventory_cloud_id){
                        item.supplier = item.company_name;
                    }
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                })
                if(this.listDetail.length===1){
                    if(!this.listDetail[0].id&&!this.listDetail[0].inventory_id){
                        this.listDetail=rows;
                        return;
                    }
                }
                this.listDetail = this.listDetail.concat(rows);
                let result = [];
                let obj = {};
                let data = this.$cloneJson(this.listDetail);
                for(let i =0; i<data.length; i++){
                    if(!obj[data[i].inventory_id]){
                        result.push(data[i]);
                        obj[data[i].inventory_id] = true;
                    }
                }
                this.listDetail = result;
        },
        getSelectList(target){
            this.$getSelectList(target).then(res=>{
                this.selectMap[res.target]=res.list;
            })
        },
        excelExport(){
            this.$exportExecl("/erp/purchase.sales.export","板材调货",this.params)
        },
        feeDelete(id){
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/purchase.cost.delete",{id:id},()=>{
                    this.tip('删除成功','success');
                    //this.getFeeList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        addFee(){
            // if(this.selectRow.length>1||this.selectRow.length<1){
            //     this.tip("请选择一条合同","warning")
            // }else{
                // if(this.selectRow[0].purchase_type==4){
                //     this.tip("请选择直接导入数据","warning")
                // }else{
                    this.isShowCost=!this.isShowCost;
                    // this.feeForm.fee_date=new Date();
                    // this.feeForm.contract_no=this.selectRow[0].contract_no;
                    this.feeForm.fee_date=new Date();
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.contract_no)
                    })
                    this.feeForm.contract_no = arr;
                    this.feeForm.contract_no_copy = arr.toString();

                // }
            // }
        },
        //新建退货单
        addReturnOrder(){
            this.purchaseTypeText = '新建采购退货单'
            this.scene = 'purchase.return.create';
            this.isGlobal = true;
            this.getBillColumn();
            this.dialogReturnVisible = true;
        },
        addTo(){
            if(this.form_params.supplier_id!=''){
                this.dialogVisibleStock = !this.dialogVisibleStock;
            }else{
               this.tip('请选择供应商',"warning") 
            }
        },
        listDetailDelete(index){
            this.listDetail.splice(index,1)
            if(this.listDetail.length < 1){
                this.listAdd()
            }
            this.calculationTableTotal()
        },
        listAdd(){
            this.listDetail.push({isEdit:true,inventory_cloud_id:"",inventory_company_id:"",bale_no:"",breed:"",brand:"",grade:"",thickness:"",length:"",width_total:"",width:[],cube:"",cube_price:"",total_amount:"",pieces:"",layer_number:"",remark:""})
        },
        calculationTableTotal(){
            // 退货金额=采购单价*码单立方
            let return_amount = 0;//退货金额
            let tax_amount = 0;//税金
            let refund_amount = 0;//
            return_amount = this.keepPrices(this.$bc_add(...this.listDetail.map(a => a.total_amount)));
            //计算税金
            if (Number(this.rec_params.rec) === 1) {
                if(this.tableTotal.tax_rec_amount) tax_rec_amount = Number(this.tableTotal.tax_rec_amount);
                let taxBase = Number(return_amount);
                let tax_rate = Number(this.rec_params.tax_rate);
                let tax_rate_real = this.$bc_div(tax_rate, 100);//税率
                if (this.rec_params.rec_type == 'DIV') {
                    //除法计算方式
                    tax_amount = this.$bc_sub(this.$bc_div(taxBase, this.$bc_sub(1, tax_rate_real)),taxBase);
                }else{
                    //乘法计算方式
                    tax_amount = this.$bc_mul(taxBase, tax_rate_real);
                }
            }
            this.tableTotal.return_amount = this.keepPrices(return_amount);
            this.tableTotal.tax_amount = this.keepPrices(tax_amount);
            this.tableTotal.refund_amount = this.keepPrices(this.$bc_add(tax_amount,return_amount));
            this.rec_params.amount = this.keepPrices(tax_amount);
        },
        //确认退货
        confirmReturn(){
            if(this.form_params.remark==''){
                this.tip('请填写退货原因','warning');
                return
            }
            if(this.ispurchaseUpdate){//修改
                this.form_params.date = this.formatTimeZero(this.form_params.date);
                this.form_params.fees = this.newFee;
                this.form_params.details = this.listDetail.map(({inventory_id}) => ({inventory_id}))
                this.postFunc('/erp/purchase.return.update',this.form_params,()=>{
                    this.tip('修改成功','success');
                    this.dialogReturnVisible = false;
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }else{
                this.form_params.date = this.formatTimeZero(this.form_params.date);
                this.form_params.fees = this.newFee;
                // this.form_params.details = this.listDetail;
                this.form_params.details = this.listDetail.map(({inventory_id}) => ({inventory_id}))
                this.postFunc('/erp/purchase.return.create',this.form_params,()=>{
                    this.tip('创建成功','success');
                    this.dialogReturnVisible = false;
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
            
        },
        outRecChanges(){
            this.recChanges = false;
        },
        settlementConfirm(){
            this.form_params.rec = this.rec_params.rec;
            this.form_params.tax_rate = this.rec_params.tax_rate;
            this.form_params.amount =  this.rec_params.amount; 
            if(this.rec_params.rec==true){
                this.f_rec=1
            }else{
                this.f_rec=0
            }
            this.rec_params.rec = this.f_rec;
            if(this.rec_params.with_ticket==1){
                delete this.rec_params.rec_type;
                delete this.rec_params.tax_rate;
            }
            this.recChanges = false;
        },
        feeChange(target){
            this.getFeeDownMess(this.feeForm.contract_no,target,this.selectRow[0].id,this.feeForm.bill_lading_no,this.feeForm.container_no)
        },
        getFeeDownMess(contract_no,target,purchase_id,bill_lading_no,container_no){
            this.postFunc("/erp/purchase.search.select",{contract_no:contract_no,target:target,purchase_id:purchase_id,bill_lading_no:bill_lading_no,container_no:container_no},res=>{
                if(target=="bill_lading_no"){
                    this.bill_lading_no_list=res.data.data.result;
                }else{
                    this.container_no_list=res.data.data.result;
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getFeeList(){
            this.postFunc("/erp/purchase.cost.list",{purchase_id:this.selectRow[0].id},res=>{
                this.feeList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        saveFee(){
            // this.feeForm.purchase_id=this.selectRow[0].id;
            let arr = new Array();
            this.selectRow.forEach(item=>{
                arr.push(item.id)
            })
            this.feeForm.purchase_id = arr;
            let time = this.feeForm.fee_date;
            this.feeForm.fee_date=this.formatTimeZero(this.feeForm.fee_date);
            this.postFuncLoading("/erp/purchase.cost.create",this.feeForm,()=>{
                this.isShowCost=!this.isShowCost;
                this.tip("添加成功","success")
                this.getList();
                //this.getFeeList()
            },error=>{
                this.feeForm.fee_date = time;
                this.tip(error.data.message,"warning")
            })
        },
        reset(){
            this.params=this.resetSearch(this.params)
            this.start_time="";
            this.end_time=new Date();
            this.payment_time="";
            // this.params.status='';
            this.getList();
        },
        getList(flag){
            if(flag){
                this.params.page = 1;
            }
            this.params.start_time=this.formatTimeZero(this.start_time)
            this.params.end_time=this.formatTimeZero(this.end_time)
            if(this.order_id){
                this.params.order_id = this.order_id;
            }
            this.tableLoading = true;
            this.$postColumnList("/erp/purchase.sales.list",this.params,res=>{
                let obj ={
                    purchase:res.data.data.count.purchase,
                    finance:res.data.data.count.finance,
                    purchaseSales:res.data.data.count.sales
                }
                this.$emit('contract-num',obj)
                this.last_page=parseInt(res.data.data.list.last_page);
                // this.params.page=parseInt(res.data.data.list.current_page);
                this.$refs.pagination.flag = true;
                this.tableLoading = false;
                this.total=parseInt(res.data.data.list.total);
                this.totalObj=res.data.data.total;
                this.list=res.data.data.list.data;
                this.list.forEach((item,index)=>{
                    item.info_summary = "查看详情";
                    if(item.contract_time!=0){
                        this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                    }else{
                        this.list[index].contract_time = ""
                    }
                    item.isEdit=true;
                    item.isDelete=true;
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        addContract(type){
            this.$refs["contractForm"].validate((valid) => {
                if (valid) {
                    let contract_time = this.contractForm.contract_time;
                    let expected_arrival_time = this.contractForm.expected_arrival_time;
                    let expected_pay_time = this.contractForm.expected_pay_time;
                    // let actual_arrival_time = this.contractForm.actual_arrival_time;
                    let payment_time = this.contractForm.payment_time;
                    // let receipt_invoice = this.contractForm.receipt_invoice;
                    let contract_no = this.contractForm.contract_no;
                    let supplier_id = this.contractForm.supplier_id;
                    // let port_id = this.contractForm.port_id;
                    let batch_no = this.contractForm.batch_no;
                    let ship_no = this.contractForm.ship_no;
                    this.contractForm.expected_pay_time=this.formatTimeZero(this.contractForm.expected_pay_time);
                    this.contractForm.payment_time=this.formatTimeZero(this.contractForm.payment_time);
                    this.contractForm.contract_time=this.formatTimeZero(this.contractForm.contract_time);
                    this.contractForm.expected_arrival_time=this.formatTimeZero(this.contractForm.expected_arrival_time);
                    var str = this.contractForm.payer;
                    this.contractForm.payer_id = str.substring(0, str.indexOf("_"));
                    var index=str.lastIndexOf("\_");
                    this.contractForm.payer_type=str.substring(index+1,str.length);
                    // this.contractForm.receipt_invoice=this.formatTimeZero(this.contractForm.receipt_invoice);
                    // this.contractForm.expected_shipping_time=this.formatTimeZero(this.contractForm.expected_shipping_time);
                    if(this.contractType==2){
                        this.postFuncLoading("/erp/purchase.wood.create",this.contractForm,()=>{
                            if(type==2){
                                this.contractForm=this.resetJson(this.contractForm);
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.contract_no = contract_no;
                                this.contractForm.supplier_id = supplier_id;
                                this.contractForm.batch_no = batch_no;
                                this.contractForm.ship_no = ship_no;
                            }else{
                                this.isShowContract = false;
                            }
                            this.tip('新增成功','success');
                            this.getList();
                        },error=>{
                            this.contractForm.contract_time = contract_time;
                            this.contractForm.expected_arrival_time = expected_arrival_time;
                            this.contractForm.expected_pay_time = expected_pay_time;
                            this.contractForm.payment_time = payment_time;
                            this.tip(error.data.message,"warning")
                        },()=>{
                            this.contractForm.contract_time = contract_time;
                            this.contractForm.expected_arrival_time = expected_arrival_time;
                            this.contractForm.expected_pay_time = expected_pay_time;
                            this.contractForm.payment_time = payment_time;
                        })
                    }else{
                        this.postFuncLoading("/erp/purchase.wood.update",this.contractForm,()=>{
                            this.isShowContract = false;
                            this.tip('修改成功','success');
                            this.getList();
                        },error=>{
                            this.contractForm.contract_time = contract_time;
                            this.contractForm.expected_arrival_time = expected_arrival_time;
                            this.contractForm.expected_pay_time = expected_pay_time;
                            this.contractForm.payment_time = payment_time;
                            this.tip(error.data.message,"warning")
                        },()=>{
                            this.contractForm.contract_time = contract_time;
                            this.contractForm.expected_arrival_time = expected_arrival_time;
                            this.contractForm.expected_pay_time = expected_pay_time;
                            this.contractForm.payment_time = payment_time;
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        getPage(obj){
            this.params.page=obj.currentpage;
            this.params.per_page=obj.pagesize;
        },
        rowClick(obj){
            if(obj.name=="contract_no"){
                if(obj.row.purchase_type==6){
                    this.purchaseTypeEdit = false;
                    this.scene = 'purchase.return.create';
                    this.isGlobal = true;
                    this.getBillColumn();
                    this.postFunc("/erp/purchase.return.info",{id:obj.id},res=>{
                        this.listDetail = res.data.data.details;
                        this.form_params = res.data.data.info;
                        this.form_params.date =  this.formatTime(this.form_params.date+"000")
                        this.form_params.rec = this.form_params.rec==1?true:false;
                        this.newFee = res.data.data.fee;
                        this.purchaseTypeText = '采购退货单'+'('+res.data.data.info.contract_no+')';
                    })
                    this.dialogReturnVisible = true;
                }else{
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_ID")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_CONTRACT_ID",obj.id)
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE",3)
                    this.$root.$children[0].$children[0].addTab({
                        name: '捆包明细'+obj.id,
                        label: '捆包明细',
                        content: 'purchaseBaleDetail'
                    });
                }
            }else if(obj.name=="remark"){
                this.list.forEach(item=>{
                    if(obj.id==item.id){
                        this.seeRemarks = item.remarks;
                        this.seeRemarksFlag = !this.seeRemarksFlag;
                    }
                })
            }else if(obj.name == "info_summary"){
                this.postFunc("/erp/purchase.sales.spec",{id:obj.id},res=>{
                    this.category = res.data.data.category;
                    this.specDetail = res.data.data.list;
                    this.cubeTotal = res.data.data.total;
                    this.specDetailFlag = true;
                })
            }else if(obj.name =="purchase_cost"){
                this.postFunc("/erp/purchase.sales.fee.list",{id:obj.id},res=>{
                    this.costDetail = res.data.data.list;
                    this.costDetail.forEach((item,index)=>{
                        if(item.fee_date!=0){
                            this.costDetail[index].fee_date = this.formatTime(item.fee_date+"000")
                        }else{
                            this.costDetail[index].fee_date = "";
                        }
                    })
                    this.costDetailFlag = true;
                })
            }
        },
        //获取费用名称
        outFeeSelectFunc(){
            this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
                this.outFeeSelect=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        outFeeChange(e){
            this.outFeeSelect.forEach(item=>{
                if(item.id==e){
                    this.businessRelationForm.fee_name = item.name;
                }
            })
        },
        newOutFee(){
            for(let key in this.businessRelationForm){
                if(this.businessRelationForm[key]==""){
                    if(key=="order_id"||key=="order_sn"||key=="remark"){
                        this.pl(key)
                    }else{
                        this.tip("请填写完整信息","warning")
                        return;
                    }
                }
            }
            // let time = this.businessRelationForm.fee_date;
            this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
            this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
            this.businessRelation=!this.businessRelation;
        },
        openbusinessRelation(){
            this.businessRelation = true;
            this.businessRelationForm.fee_date = this.sales_time;
        },
        amend(){
            this.recChanges = !this.recChanges;
            this.f_rec = this.form_params.rec;
            // this.rec_params.rec = this.form_params.rec;
            this.rec_params.rec = this.form_params.rec==1?true:false;
            this.rec_params.tax_rate = this.form_params.tax_rate;
        },
        getTableDelete(id){
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/purchase.sales.delete",{id:id},()=>{
                    this.tip('删除成功','success');
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        getTableSee(id){
            this.pl(id)
        },
        getTableEdit(id,obj){
            if(obj.purchase_type==6){
                this.purchaseTypeEdit = true;
                this.ispurchaseUpdate =true;
                this.scene = 'purchase.return.create';
                this.isGlobal = true;
                this.getBillColumn();
                this.postFunc("/erp/purchase.return.info",{id:obj.id},res=>{
                    this.listDetail = res.data.data.details;
                    this.form_params = res.data.data.info;
                    this.form_params.date =  this.formatTime(this.form_params.date+"000")
                    this.form_params.rec = this.form_params.rec==1?true:false;
                    this.newFee = res.data.data.fee;
                    this.purchaseTypeText = '修改采购退货单'+'('+res.data.data.info.contract_no+')';
                })
                this.dialogReturnVisible = true;
            }else{
                this.purchaseType = 0;
                this.purchaseForm.contract_no =obj.contract_no;
                this.purchaseForm.supplier_id =obj.supplier_id;
                this.purchaseForm.bill_lading_no =obj.bill_lading_no;
                this.purchaseForm.container_no =obj.container_no;
                this.purchaseForm.remark =obj.remark;
                this.purchaseForm.id = id;
                this.isEditPurchase = true;
            }
        },
        //修改
        purchaseUpdate(){
            this.postFuncLoading('/erp/purchase.sales.update',this.purchaseForm,res=>{
                this.tip('修改成功','success');
                this.isEditPurchase = false;
                this.getList();
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        relativeFile(obj){
            this.downLoadFileDialog = !this.downLoadFileDialog;
            this.downFilesList = obj.files;
        },
        bacthUpFile(){
            if(this.selectRow.length<1){
                this.tip("请选择数据","warning")
            }else{
                let arr = new Array();
                this.selectRow.forEach(item=>{
                    arr.push(item.id)
                })
                this.upFileObj.ids = arr;
                if(this.selectRow.length == 1){
                    this.upFileList = JSON.parse(JSON.stringify(this.selectRow[0].files));
                }
                this.dialogVisibleFile = true;
                this.isUpImg = 2;
            }
        },
        //期初导入
        handleSuccess(res) {
            let obj = new Object();
            obj.url = res.data.base_url;
            obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/")+1,res.data.filename.length)
            this.upFileList.push(obj)
            this.$refs.upload_path.clearFiles();
            this.tip('文件上传成功', 'success');
            //this.importFile();
        },
        saveFile(){
            this.$confirm('是否确认上传?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.upFileObj.files = this.upFileList;
                this.postFuncLoading("/erp/purchase.upload.files",this.upFileObj,()=>{
                    this.tip('上传成功','success');
                    this.dialogVisibleFile = false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        upFileRemove(url){
            this.upFileList.forEach((item,index)=>{
                if(item.url == url){
                    this.upFileList.splice(index,1)
                }
            })
        },
        getRow(row){
            this.selectRow=row;
        },
        beforeUpload(file) {
            this.file = file;
            return this.getOss();
        },
        getOss(){
            let self = this;
            return new Promise((resolve, reject) =>{
                window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                    operate_code : "shop-excel"
                }).then((response) => {
                    if(response.data.code == 0){
                        self.oss = response.data.data;
                        this.upload_data = {
                            name: self.file.name,
                            key : self.oss.dir + "${filename}",
                            policy : self.oss.policy,
                            OSSAccessKeyId : self.oss.accessid,
                            success_action_status : "200",
                            callback : self.oss.callback,
                            signature : self.oss.signature,
                            'Cache-Control' : self.oss.cache_control,
                        }
                        resolve();
                    }
                }).catch(()=>{
                    reject();
                })
            })
        }
    },
    components:{
        tabletem,
        pagination,
        relativeFile
    },
    watch:{
        "params.page":function(){
            this.getList();
        },
        "params.per_page":function(){
            this.getList();
        },
        "isShowContract":function(val){
            if(!val){
                this.contractForm=this.resetJson(this.contractForm)
                this.categoryList.length==1?this.contractForm.category=this.categoryList[0].id:'';
                this.contractForm.remarks=[];
                this.$refs.contractForm.clearValidate()
                // this.actual_arrival_time="";
                // this.payment_time="";
                // this.receipt_invoice="";
                // this.contract_time="";
                // this.expected_arrival_time="";
                // this.expected_shipping_time="";
            }
        },
        "isShowCost":function(val){
            if(!val){
                this.feeForm=this.resetJson(this.feeForm)
            }
        },
        "dialogVisibleFile":function(val){
            if(!val){
                this.isUpImg = 0;
                this.upFileObj = {ids:[],files:[]}
                this.upFileList = [];
            }
        },
        "dialogReturnVisible":function(val){
            if(!val){
                this.form_params.returner_id = localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "";
                this.form_params.rec = 0;
                this.form_params.fees = [];
                this.form_params.details = [];
                this.form_params.remark = "";
                this.form_params.ship_no = "";
                this.ispurchaseUpdate = false;
                this.newFee =[];
                this.rec_params={rec:'',rec_type:'MUL', with_ticket:'',tax_rate:'',amount:'',remark:'',},
                this.listDetail = this.$cloneJson(initDetailList)
                this.purchaseTypeEdit = true;
            }
        },
        listDetail: {
            immediate: true,
            deep: true,
            handler: function () {
                // if (this.orderIsEdit) {
                // this.listDetail.map(a => {
                //     a.sales_cube=="" || !a.sales_cube?0:a.sales_cube;
                //     a.sales_price=="" || !a.sales_price?0:a.sales_price;
                //     a.sales_amount = isNaN(this.keepPrice(this.$bc_mul(a.sales_cube, a.sales_price)))?'':this.keepPrice(this.$bc_mul(a.sales_cube, a.sales_price));
                // });                
                // }
                    this.calculationTableTotal();
            }
        },
        "form_params.rec": function () {
            this.calculationTableTotal();
        },
        "rec_params.rec_type": function () {
            this.calculationTableTotal();
        },
        "rec_params.tax_rate": function () {
            this.calculationTableTotal();
        },
        "rec_params.with_ticket":function(){
            this.rec_params.amount = "";
            this.rec_params.tax_rate = "";
        },
    }
}
</script>
